import {Link} from "react-router-dom";
import React from "react";
import MaterialIcon from "../../../../MaterialIcon";

export const LogicVersionItem = ({versionItem, logicId}) => {
  const logicVersion = versionItem.version;

  return (<div className="version-item">
    <div className="version-value">
      <Link
          to={`/logics/${logicId}/versions/${logicVersion}`}>Version: {logicVersion}</Link>
    </div>
    <div className="version-date-creation">
      Creation date: {versionItem.creationDate}
    </div>
  </div>)
}